import React, { Suspense } from 'react'
import { CContainer, CSpinner } from '@coreui/react'
import { Outlet } from "react-router-dom";

const AppContent = () => {
  return (
    <CContainer fluid>
      <Suspense fallback={<CSpinner color="primary" />}>
        <Outlet />
      </Suspense>
    </CContainer>
  )
}

export default React.memo(AppContent)
